module.exports = {
	"7": {
		"chart": {
			"width": null,
			"height": 500,
			"marginRight": 110
		}
	},
	"8": {
		"chart": {
			"width": 600,
			"height": 600,
			"marginLeft": 100,
			"marginRight": 100
		}
	},
	"9": {
		"chart": {
			"width": null,
			"height": 500,
			"marginRight": 60
		}
	},
	"10": {
		"chart": {
			"width": 700,
			"height": 600
		}
	},
	"12": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"13": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.2": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.3": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.4": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.5": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.6": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"1.7": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"2.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"2.2": {
		"chart": {
			"width": null,
			"height": 500,
			"marginLeft": 100,
			"marginRight": 60
		}
	},
	"2.3": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"3.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"3.2": {
		"chart": {
			"width": null,
			"height": 500,
			"marginLeft": 150,
			"marginRight": 150
		}
	},
	"3.3": {
		"chart": {
			"width": null,
			"height": 500,
			"marginRight": 60
		}
	},
	"3.4": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"3.5": {
		"chart": {
			"width": null,
			"height": 700
		}
	},
	"4.1": {
		"chart": {
			"width": 300,
			"height": 430
		}
	},
	"4.2": {
		"chart": {
			"width": 600,
			"height": 430
		}
	},
	"4.3": {
		"chart": {
			"width": 1000,
			"height": 430
		}
	},
	"4.4": {
		"chart": {
			"width": 800,
			"height": 430
		}
	},
	"5.1": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.3": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.4": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.5": {
		"chart": {
			"width": null,
			"marginLeft": 80
		}
	},
	"5.6": {
		"chart": {
			"marginLeft": 80
		}
	},
	"5.7": {
		"chart": {
			"width": null,
			"marginLeft": 80
		}
	},
	"6.1": {
		"chart": {
			"width": null,
			"height": 500
		}
	},
	"6.2": {
		"chart": {
			"width": 500,
			"height": 600
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/web/override.json
// module id = 142
// module chunks = 0